/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GarageSpotAttributeDtoSortedPagedListResponseFromJSON, GarageSpotAttributeDtoSortedPagedListResponseToJSON, } from './';
export function GarageSpotAttributeDtoSortedPagedListResponseGenericApiResponseFromJSON(json) {
    return GarageSpotAttributeDtoSortedPagedListResponseGenericApiResponseFromJSONTyped(json, false);
}
export function GarageSpotAttributeDtoSortedPagedListResponseGenericApiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'content': !exists(json, 'content') ? undefined : GarageSpotAttributeDtoSortedPagedListResponseFromJSON(json['content']),
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}
export function GarageSpotAttributeDtoSortedPagedListResponseGenericApiResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'content': GarageSpotAttributeDtoSortedPagedListResponseToJSON(value.content),
        'errors': value.errors,
    };
}
